import { Line, Text, Wrapper } from './Divider.styles';
import type { DividerProps } from './Divider.types';

export function Divider({ text, spacing = 'default' }: DividerProps) {
  if (!text) {
    return (
      <Wrapper $spacing={spacing}>
        <Line />
      </Wrapper>
    );
  }

  return (
    <Wrapper $spacing={spacing}>
      <Line />
      <Text>{text}</Text>
      <Line />
    </Wrapper>
  );
}
